<div class="flex flex-col items-center justify-center h-screen">
  <h2 fxFlex>UNDER CONSTRUCTION</h2>
</div>
